import Cookies from 'js-cookie';
import type { SourcebusterData } from '../model/types';

const SOURCEBUSTER_CURRENT_COOKIE = 'sbjs_current';
const SOURCEBUSTER_DELIMITER = '|||';
const SOURCEBUSTER_KEYS: ReadonlySet<string> = new Set<keyof SourcebusterData>(['src', 'mdm', 'cmp', 'cnt', 'trm']);

function decodeSourcebusterValue(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

function isSourcebusterKey(key: string): key is keyof SourcebusterData {
  return SOURCEBUSTER_KEYS.has(key);
}

export function parseSourcebusterData(cookieValue: string): SourcebusterData {
  const data: SourcebusterData = {};

  for (const pair of cookieValue.split(SOURCEBUSTER_DELIMITER)) {
    const separatorIndex = pair.indexOf('=');

    if (separatorIndex === -1) {
      continue;
    }

    const key = pair.slice(0, separatorIndex);

    if (isSourcebusterKey(key)) {
      data[key] = decodeSourcebusterValue(pair.slice(separatorIndex + 1));
    }
  }

  return data;
}

export function getSourcebusterData(): SourcebusterData {
  const cookieValue = Cookies.get(SOURCEBUSTER_CURRENT_COOKIE);

  return cookieValue ? parseSourcebusterData(cookieValue) : {};
}
